export const SocialData = [
  {
    platform: 'GitHub',
    link: 'https://github.com/nonatodiego',
    icon: require('../../assets/icons/github.svg').default,
  },
  {
    platform: 'Linkedin',
    link: 'https://www.linkedin.com/in/diegononato/',
    icon: require('../../assets/icons/linkedin.svg').default,
  },
  {
    platform: 'Email',
    link: 'mailto:diegononatodev@gmail.com?subject=Olá%20Diego',
    icon: require('../../assets/icons/gmail.svg').default,
  },
]